import { gambits } from '@/core/gambits';
import { useAuthStore } from '@/stores/auth.store';
import { useEventListener } from '@vueuse/core';

/** Matches the API's throttle window, so "last active" is accurate to about five minutes. */
const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;

/**
 * Tells the API the member is using the app: on open, on coming back to the
 * foreground, and on interaction. Hidden tabs and idle screens send nothing,
 * and nothing waits on the request.
 */
export function useActivityHeartbeat() {
  const authStore = useAuthStore();
  let lastSentAt = 0;

  const beat = () => {
    if (document.visibilityState !== 'visible' || !authStore.isAuthenticated()) return;

    const now = Date.now();
    if (now - lastSentAt < HEARTBEAT_INTERVAL_MS) return;

    lastSentAt = now;
    void gambits.userService.markActive();
  };

  for (const event of INTERACTION_EVENTS) {
    useEventListener(window, event, beat, { passive: true, capture: true });
  }
  useEventListener(document, 'visibilitychange', beat);

  return { beat };
}
